import { GetWorkflowTemplateResponse } from "../../../../../../../service/query";
import { DealApplyWorkflowTemplatePanel } from "./components/DealApplyWorkflowTemplatePanel";
import { ProjectApplyWorkflowTemplatePanel } from "./components/ProjectApplyWorkflowTemplatePanel";

interface ApplyWorkflowTemplatePanelProps {
  defaultDealUuid?: string;
  defaultProjectUuid?: string;
  workflowTemplateUuid: string | undefined;
  workflowTemplate: GetWorkflowTemplateResponse | undefined;
  show: boolean;
  onClose: () => void;
}

export const ApplyWorkflowTemplatePanel = ({
  defaultDealUuid,
  defaultProjectUuid,
  workflowTemplateUuid,
  workflowTemplate,
  show,
  onClose,
}: ApplyWorkflowTemplatePanelProps): JSX.Element => {
  if (workflowTemplate?.type === "Deal") {
    return (
      <DealApplyWorkflowTemplatePanel
        defaultDealUuid={defaultDealUuid}
        show={show}
        workflowTemplate={workflowTemplate}
        workflowTemplateUuid={workflowTemplateUuid}
        onClose={onClose}
      />
    );
  }

  return (
    <ProjectApplyWorkflowTemplatePanel
      defaultProjectUuid={defaultProjectUuid}
      workflowTemplateUuid={workflowTemplateUuid}
      workflowTemplate={workflowTemplate}
      show={show}
      onClose={onClose}
    />
  );
};
